import React from 'react';
import { Row } from '@amzn/atoz-web/Row';
import { View } from '@amzn/atoz-web/View';
import { Card } from '@amzn/atoz-web/Card';
import { StopPropagationContainer } from '../shared';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var ShiftCard = function (_a) {
    var viewShiftDetailsButton = _a.viewShiftDetailsButton, actionsButton = _a.actionsButton, scheduleShift = _a.scheduleShift, shiftInfo = _a.shiftInfo, shiftIntervalList = _a.shiftIntervalList, payLabel = _a.payLabel, shiftCardStatus = _a.shiftCardStatus;
    return (React.createElement(View, { role: "listitem" },
        React.createElement(Card, { "data-testid": "ShiftCard-".concat(scheduleShift.shift.id), flexDirection: "column" },
            React.createElement(Row, { justifyContent: "space-between" },
                shiftInfo,
                payLabel),
            shiftIntervalList,
            shiftCardStatus,
            React.createElement(ButtonsRow, { justifyContent: "flex-end", gridGap: 'S200' },
                viewShiftDetailsButton,
                React.createElement(StopPropagationContainer, null, actionsButton)))));
};
var ButtonsRow = styledWithTheme(Row)(function (_a) {
    var theme = _a.theme;
    return "\n    justify-content: flex-end;\n    margin-top: ".concat(theme.selectors.space('S200'), "px;\n");
});
